import Proxy from '../Proxy';

class OrderBaseOptimizedProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('orders-base-optimized', parameters);
  }
}

export default OrderBaseOptimizedProxy;
